import { ReactNode } from 'react';
import { Typography } from 'src/latest/src/components';
import { Weight } from "src/latest/src/types";

interface TextProps {
  children: string | ReactNode;
  weight?: Weight;
  className?: string;
}

export const Text = ({
  children,
  weight = 'regular',
  className = '',
}: TextProps) => (
  <Typography
    variant="size-18"
    weight={weight}
    color="color-2"
    className={className}
  >
    {typeof children === 'string' &&
    (children.includes('span') || children.includes('<a')) ? (
      <span dangerouslySetInnerHTML={{ __html: children }} />
    ) : (
      children
    )}
  </Typography>
);
